import Tooltip from '@mui/material/Tooltip'
import Stack from '@mui/material/Stack'
import { SvgIcon, Typography } from '@mui/material'
import React, { ComponentProps } from 'react'
import { ReactComponent as ArchiveIcon } from '../../../../assets/images/actions/archive.svg'
import { ValueNarrative } from '../../queries/useGetValueNarrativesQuery'

type ValueNarrativeArchiveIconProps = Pick<ComponentProps<typeof SvgIcon>, 'sx'> & {
    archived: ValueNarrative['archived']
}

const ValueNarrativeArchiveIcon = ({ sx, archived }: ValueNarrativeArchiveIconProps) => {
    return (
        <Tooltip
            placement="top-start"
            arrow
            title={
                <Stack gap={1} overflow="scroll">
                    <Typography
                        variant="14x400"
                        color="figma.grayscale.textHier1"
                        sx={{
                            whiteSpace: 'pre-line',
                            overflow: 'scroll',
                            maxHeight: '50vh',
                        }}
                    >
                        Archived by{' '}
                        <Typography variant="14x600" color="figma.grayscale.textHier1">
                            {archived.archivedBy.name}
                        </Typography>
                        ,{'\n'}{' '}
                        {new Date(archived.archivedAt).toLocaleDateString('en-US', {
                            year: 'numeric',
                            month: 'long',
                            day: 'numeric',
                        })}
                        {archived.archivedNote && (
                            <>
                                ,{'\n'}
                                <Typography variant="14x600" color="figma.grayscale.textHier1">
                                    Note:{' '}
                                </Typography>
                                {archived.archivedNote}
                            </>
                        )}
                    </Typography>
                </Stack>
            }
            componentsProps={{
                tooltip: {
                    sx: {
                        backgroundColor: 'figma.grayscale.contentWrapper',
                        px: 2,
                        py: 0.5,
                        borderRadius: '6px',
                        boxShadow: '0px 4px 8px 0px rgba(0, 0, 0, 0.20);',
                    },
                },
                arrow: {
                    sx: {
                        color: 'figma.grayscale.contentWrapper',
                    },
                },
            }}
        >
            <SvgIcon
                component={ArchiveIcon}
                inheritViewBox
                fontSize="small"
                color="primary"
                sx={[
                    {
                        fontSize: '20px',
                        cursor: 'help',
                    },
                    ...(Array.isArray(sx) ? sx : [sx]),
                ]}
            />
        </Tooltip>
    )
}

export default ValueNarrativeArchiveIcon
